import { EuiThemeModifications } from '@elastic/eui';
import { tokens } from './tokens';

export const theme: EuiThemeModifications = {
  colors: {
    LIGHT: { primary: tokens.colors.primary, accent: tokens.colors.accent },
    DARK: { primary: tokens.colors.primary, accent: tokens.colors.accent },
  },
};
